module.exports = __webpack_public_path__ + "media/images/banner/japanesecrafts/th-02ef049956fc5b7621d38cde0595ace3.png";